export default __webpack_public_path__ + "static/media/product.bd10e80a.png";